import { styled as r } from "styled-components";
import { Colors as o } from "../../styles/colors/index.js";
import { Theme as e } from "../../styles/themes/index.js";
const p = r.div`
  display: flex;
`, a = r.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: rgb(${o.Gray});
  margin-right: 9px;

  &[aria-pressed='true'] {
    background-color: rgb(${e.colors.Brand});
  }
`;
export {
  p as StepProgressBarContainer,
  a as StepProgressStepCircle
};
